/* eslint-disable no-console */
import { fromError } from 'stacktrace-js';
import { getRequestConfigHeaderField } from '../../_internal/get-request-config-header-field';
import { getRandomTraceId } from '../../api/utils/get-random-trace-id';
import { CSRF_COOKIE_NAME } from '../../constants/csrf-cookie-name';
import { AdditionalHeaders } from '../../constants/headers';
import { NEWCLICK_SERVICES_BASE_URL } from '../../constants/services-base-url';
import { getCookie } from '../../utils/cookies';
import { BROWSER_ERROR_LOG_PATH, BROWSER_INFO_LOG_PATH } from '../constants';
import { isBrowserExtensionError } from './utils/is-browser-extension-error';
let sendError;
let sendInfo;
let sendBrowserApiError;
export class BrowserLog {
    abortController;
    appId;
    static sendError = (error, payload) => sendError
        ? sendError(error, payload)
        : Promise.resolve('Function sendBrowserError is not initialized!');
    static sendBrowserApiError = (error, requestConfig) => sendBrowserApiError
        ? sendBrowserApiError(error, requestConfig)
        : Promise.resolve('Function sendBrowserApiError is not initialized!');
    static sendInfo = (info, payload) => sendInfo
        ? sendInfo(info, payload)
        : Promise.resolve('Function sendBrowserInfo is not initialized!');
    sendErrorApiMethod = async (error, payload) => {
        try {
            const stackFrames = await fromError(error);
            if (isBrowserExtensionError(stackFrames))
                return undefined;
            await fetch(`${NEWCLICK_SERVICES_BASE_URL}${BROWSER_ERROR_LOG_PATH}/${this.appId}`, {
                method: 'POST',
                body: JSON.stringify({
                    message: error.message,
                    stackFrames,
                    payload,
                }),
                headers: {
                    [AdditionalHeaders.Xsrf]: getCookie(CSRF_COOKIE_NAME) || '',
                    [AdditionalHeaders.TraceId]: getRandomTraceId(),
                    [AdditionalHeaders.SpanId]: getRandomTraceId(),
                },
                signal: this.abortController?.signal,
                redirect: 'manual',
            });
        }
        catch (e) {
            console.warn('Browser error did not send!', e);
        }
        return undefined;
    };
    sendBrowserErrorApiMethod = async (error, requestConfig) => {
        try {
            const stackFrames = await fromError(error);
            const traceId = getRequestConfigHeaderField(requestConfig, 'x-b3-traceid') || getRandomTraceId();
            const spanId = getRequestConfigHeaderField(requestConfig, 'x-b3-spanid') || getRandomTraceId();
            if (isBrowserExtensionError(stackFrames))
                return undefined;
            await fetch(`${NEWCLICK_SERVICES_BASE_URL}${BROWSER_ERROR_LOG_PATH}/${this.appId}`, {
                method: 'POST',
                body: JSON.stringify({
                    message: `Browser Api Request Error: ${error.message}, Url: ${requestConfig.url}`,
                    serverLoggerMessage: 'Browser API Error',
                    stackFrames,
                    requestConfig,
                }),
                headers: {
                    [AdditionalHeaders.Xsrf]: getCookie(CSRF_COOKIE_NAME) || '',
                    [AdditionalHeaders.TraceId]: traceId,
                    [AdditionalHeaders.SpanId]: spanId,
                },
                signal: this.abortController?.signal,
                redirect: 'manual',
            });
        }
        catch (e) {
            console.warn('Browser API error did not send!', e);
        }
        return undefined;
    };
    sendInfoApiMethod = async (message, payload) => {
        try {
            await fetch(`${NEWCLICK_SERVICES_BASE_URL}${BROWSER_INFO_LOG_PATH}/${this.appId}`, {
                method: 'POST',
                body: JSON.stringify({
                    message,
                    payload,
                }),
                headers: {
                    [AdditionalHeaders.Xsrf]: getCookie(CSRF_COOKIE_NAME) || '',
                    [AdditionalHeaders.TraceId]: getRandomTraceId(),
                    [AdditionalHeaders.SpanId]: getRandomTraceId(),
                },
                signal: this.abortController?.signal,
                redirect: 'manual',
            });
        }
        catch (e) {
            console.warn('Browser info did not send!', e);
        }
        return undefined;
    };
    constructor({ appId }) {
        this.appId = appId;
        sendError = (error, payload) => this.sendErrorApiMethod(error, payload);
        sendBrowserApiError = (error, requestConfig) => this.sendBrowserErrorApiMethod(error, requestConfig);
        sendInfo = (info, payload) => this.sendInfoApiMethod(info, payload);
    }
    destroy = () => {
        this.abortController?.abort();
        sendError = null;
        sendBrowserApiError = null;
        sendInfo = null;
    };
}
